<template >
  <sc-panel-navigator
      @removeContact="removeContact"
      @updateBusiness="updateBusiness"
      :drawerWidth="400" >
    <div
        class="drawer-content"
        style="border:1px solid white;" >
      <el-row style="background-color: #009688;" >
        <!-- <p>~~{{getStore('mergeFromBusinessId')}}</p> -->
        <el-col :span="20" >
          <h4
              style="font-weight: 700; padding-left: 20px;" >{{ ctx == "in" ? "Customers" : "Sappliers" }}</h4 >
        </el-col >
        <el-col :span="4" >
          <el-button
              style="float: right;"
              @click="$router.push({ params: { id: 'new' } })"
              type="primary"
              plain
              size="small"
              title="Νέα επαφή" >
            <i class="material-icons" >person_add</i >
          </el-button >
        </el-col >
      </el-row >
      <el-row style="margin: 5px;" >
        <el-col
            :md="21"
            :xs="19" >
          <el-input
              placeholder="Όνομα, ΑΦΜ, Περιγραφή..."
              clearable
              v-model="searchContact" ></el-input >
        </el-col >
        <el-col
            :md="3"
            :xs="5" >
          <el-checkbox
              style="padding-left:5px;"
              v-model="includeArchived"
              title="Display also disabled contacts" >
            <i class="material-icons" >people_alt</i >
          </el-checkbox >
        </el-col >
      </el-row >
      <el-row >
        <ctk-dater
            range
            v-model="bookingRange"
            display-format="dd/MM/yyyy"
            export-format="DD/MM/YYYY"
            valueFormat="onurl"
            default="1months"

        ></ctk-dater >
      </el-row >
      <s-table
          :key="$route.params.view"
          v-if="loaded"
          :topOffset="40"
          row-key-field="businessId"

          :row-class-factory="rowStyler"
          :selectionId="$route.params.id"
          :colDefinitions="colDefinitions"
          modx-processor="business/vuegetlist"
          :r-query="qBusinesss"
          @cell-clicked="loadView"
          v-model="listedContacts"
          ref="listedContacts" ></s-table >
    </div >
  </sc-panel-navigator >
</template >

<script >
import {mapActions, mapMutations, mapGetters} from "vuex";
import _ from "lodash";
import format from "date-fns/format";
import * as api from "~/api/resource";

export default {
  data() {
    return {
      clock: 0,
      // ctx: "in",
      includeArchived: false,
      workingBusinessId: null,
      drawerIsOpen: true,
      searchContact: null,
      searchTransactions: null,
      overviewState: "contact",
      dateRange: [],
      listedContacts: [],
      selectedContact: {},
      canEdit: true,
      aggregators: {cost: 0, costincl: 0},
      contentFrame: "width:calc(100vw - 700px);",
      drawerWidth: window.innerWidth < 500 ? window.innerWidth : 500,
      loaded: false,
      userProfile: UserProfile,
      printerLang: "gr",
      dateFormat: "DD/MM/YY",
    };
  },
  watch: {
    "$route.params.direction"(v, vo) {
      _log_("route..", v, vo);
      if (vo && v != vo) {
        if (this.ctx != v) {
          // this.ctx = v;
          ++this.clock;
        }
      }
      // this.$nextTick(() => {
      //   this.toggleDrawer(true);
      // });
      //     this.ctx=(this.$route.name.indexOf('in')==0)?'in':'out'
      // const date = new Date();
      // this.qRange = [date.getTime(), date.getTime() + 3600 * 1000 * 24 * 91];
    },
  },
  methods: {
    removeContact(e) {
      // _log_("removeContact//.", e);
      if (!e) return;
      var rowSelector = {businessId: e.businessId ? e.businessId : e};
      this.$refs.listedContacts.updateRow(rowSelector, {
        afm: "--",
        alias: "--",
        name: "--",
        balances: null,
        depts: null,
        payments: null,
      });
    },
    updateBusiness(e) {
      _log_("rup..Contact//.", e);
      var rowSelector = {businessId: e.businessId};
      this.$refs.listedContacts.reloadRow(e.businessId);
    },
    ...mapMutations({
      setStore: "helpers/setStore",
    }),
    cancelContact() {
      const vm = this;
      if (this.selectedContact.aa && this.selectedContact.aa + "" != "0")
        this.$confirm(
            "Θελεις να το " +
            (vm.selectedContact.canceled != 1 ? "ακυρώσεις" : "επαναφερεις"),
            "ΠΡΟΣΟΧΗ!!!",
            {
              confirmButtonText: "Ναι",
              cancelButtonText: "Άστο καλήτερα",
              type: "warning",
              center: true,
            }
        )
            .then(() => {
              vm.selectedContact.canceled =
                  vm.selectedContact.canceled == 1 ? 0 : 1;
              vm.updateContact(vm.selectedContact);
            })
            .catch(() => {
            });
      this.setStore({
        storename: "mergeFromBusinessId",
        data: this.value.businessId,
      });
    },
    contactListClass(k) {
      var cls = "";
      if (k.row.canceled == 1) cls += " canceled-contact";
      if (k.row.aa > 0) cls += " issued-contact";
      else cls += " not-issued-contact";
      return cls;
    },
    selectOverviewState(k) {
      this.overviewState = k;
    },

    async updateContact(inv_data) {
      if (!inv_data) inv_data = this.selectedContact;
      if (!inv_data) return;
      const data = await api.updateProcessor("timologio/update", inv_data);
      this.selectedContact = data;
      _log_("inv is...", this.selectedContact);
      this.updateArrayElement(
          this.listedContacts,
          this.selectedContact,
          "timologioId",
          true
      );
      return data;
    },
    newContact() {
      this.canEdit = true;
      this.selectedContact = {
        timologioId: null,
        editable: 1,
        aa: 0,
        open: 1,
        date: format(new Date(), "DD/MM/YYYY"),
        vat: 24,
        place: "Ζακυνθος",
      };
      this.listedContacts.unshift(this.selectedContact);
      // this.$refs.listedContacts.appendRecord(this.selectedContact)
    },
    toggleDrawer(v) {
      _log_("TODO IMPLEMENT", v);
      // this.$refs.sidePanel.toggle(v);
    },
    async changeBusiness(e) {
      this.workingBusiness = e;
      // _log_("hell..ccc.", e);
      if (this.selectedContact.businessId != e.businessId) {
        this.selectedContact.businessId = e.businessId;
        this.updateContact();
      }
      else {
        this.selectedContact.business_name = e.name;
        this.selectedContact.business_afm = e.afm;
        this.selectedContact.business_alias = e.alias;
      }
      // if (this.selectedContact.nvoiceid) {
      //new

      // this.$refs.updateContacts.appendRecord(this.selectedContact)

      // }
      // e=>(selectedContact.businessId=e.businessId)
    },
    handleContentFrame(pix) {
      if (this.isMobileDevice()) {
        this.contentFrame = "width:100vw;";
        return;
      }
      if (pix === true) {
        this.drawerIsOpen = pix;
        pix = this.drawerWidth;
      }
      if (pix === false) {
        this.drawerIsOpen = pix;
        pix = 0;
      }
      // pix=700
      if (_.isNumber(pix))
        this.contentFrame = "width:calc(100vw - " + (pix + 3) + "px);";
    },

    async loadView(d) {
      this.routeGo({
        name:
            this.userDomain == "leludi" ? "flattransview" : "tripTransactions",
        params: {
          id: d.row.businessId,
        },
      });
      if (window.innerWidth < 900) this.toggleDrawer();
    },

    alert(msg) {
      _log_("hell...", msg);
    },
    setRange(dateOne, dateTwo) {
      this.qRange = [new Date(dateOne).getTime(), new Date(dateTwo).getTime()];
    },
    formatDates() {
      const dateOne = this.qRange[0],
          dateTwo = this.qRange[1];
      // this.qRange = [new Date(dateOne).getTime(), new Date(dateTwo).getTime()];
      let formattedDates = "";
      if (dateOne && dateOne != "") {
        formattedDates = format(new Date(dateOne), this.dateFormat);
      }
      if (dateTwo && dateTwo != "") {
        formattedDates += " - " + format(new Date(dateTwo), this.dateFormat);
      }
      return formattedDates;
    },

    rowStyler(r) {
      const row = r.row;
      // _log_("bokk,,,", row);
      row.payments =
          row.payments && row.payments != "" ? parseFloat(row.payments) : 0;
      row.depts = row.depts && row.depts != "" ? parseFloat(row.depts) : 0;

      return (
          "row-" +
          (row.payments - row.depts < 0 ? "dept" : "payment") +
          " " +
          (row.archive && this.$route.params.view == "contact"
              ? "row-archived"
              : "")
      );
    },

    goToContact(data) {
      window.open(
          "/contacts/&contactid=" +
          data.row.inv_timologioId +
          "&sira=" +
          data.row.inv_kind +
          "&timo_group=" +
          data.row.inv_timo_group,
          "_blank"
      );
      // this.routeGo({
      //   name: "EditBooking",
      //   query: { bkid: data.row.idBooking }
      // });
    },
  },
  async mounted() {
    // this.ctx = this.$route.params.direction;
    _log_("GO FOR ??????????????????????????", this.ctx);
    const date = new Date();
    this.qRange = [date.getTime(), date.getTime() + 3600 * 1000 * 24 * 91];
    this.toggleDrawer(true);
    if (window.innerWidth > 901) this.heightWish = "50%";
    else this.heightWish = "50%";
    if (this.isMobileDevice()) this.heightWish = "100%";
    this.loaded = true;
    _log_("GO FOR ", this.ctx);
  },
  computed: {
    ...mapGetters({
      getStore: "helpers/getStore",
    }),

    printLink() {
      var urlprfx = "";
      if (this.workingBusiness && this.workingBusiness.externalLinkId) {
        var prfx = this.workingBusiness.externalLinkId.split("printer:");
        if (prfx[1] && prfx[1] != "") urlprfx = prfx[1] + "-";
      }
      var l = urlprfx + this.userProfile.printer_link;
      l +=
          "&pdf=full&objectId=" +
          this.selectedContact.timologioId +
          "&headerHeight=51&objectClass=Timologio&action=view&printmode=" +
          this.printerLang;
      return l;
      //"printerPrfx()+'[[!~[[!+printer:getPrinter]]]]&pdf=full&objectId='+Timologio.timologioId+'&headerHeight=51&objectClass=Timologio&action=view&printmode='+Lang"
    },
    range: {
      set(range) {
        this.$store.commit("dateRange", range);
      },
      get(range) {
        return this.$store.state.dateRange;
      },
    },
    qBusinesss() {
      // _log_("change q ", this.ctx);
      // if (this.$route.params.view == "tags")
      //   return {
      //     archived_state: this.includeArchived ? null : "active",
      //     // isbusiness: 1,
      //     mode: "full",
      //     limit: 40,
      //     csearch: "",
      //     view: "extented",
      //     group: "tags",
      //     sort: "tags",
      //     dir: "ASC",
      //     search: this.searchContact,
      //     transctx: this.$route.params.direction,
      //     rangeApplyOnTime: true,
      //     rangeApplyOnAlert: false,
      //   };
      // if (this.$route.params.view == "places")
      //   return {
      //     archived_state: this.includeArchived ? null : "active",
      //     // isbusiness: 1,
      //     mode: "full",
      //     limit: 40,
      //     csearch: "",
      //     view: "extented",
      //     group: "place",
      //     sort: "place",
      //     dir: "ASC",
      //     search: this.searchContact,
      //     transctx: this.$route.params.direction,
      //     rangeApplyOnTime: true,
      //     rangeApplyOnAlert: false,
      //   };
      let q= {
        archived_state: this.includeArchived ? null : "active",
        mode: "full",
        limit: 40,
        search: this.searchContact,
        isbusiness: this.$route.params.direction == "in" ? 1 : 0,
        sort: "Business.name",
        dir: "ASC",
        rangeApplyOnTime: true,
        rangeApplyOnAlert: false,
      };
      if(this.$route.query.timerange_from) q.timerange_from=this.$route.query.timerange_from
      if(this.$route.query.timerange_to) q.timerange_to=this.$route.query.timerange_to
      return q;
    },
    qTransactions() {
      return {
        active: 1,
        mode: "full",
        limit: 40,
        csearch: this.searchContact,
        view: "extented",
        group: "business",
        sort: "Business.name",
        dir: "ASC",
        transctx: this.ctx,
        rangeApplyOnTime: true,
        rangeApplyOnAlert: false,
      };
    },

    colDefinitions() {
      const vm = this;
      _log_("ovsa  ", this.overviewState);

      return [
        {
          prop: "name",
          minWidth: 150,
          label: "Contact",
          formatter(val, colDefs, row) {
            if (row.alias && row.alias != "") return row.alias;
            return (
                row.name +
                (row.afm ? '<span class="quote">' + row.afm + "</sapn>" : "")
            );
            // row.alias
            //   ? row.alias
            //   : row.name +
            //     (row.afm ? '<span class="quote">' + row.afm + "</sapn>" : "");
          },
        },

        {
          prop: "payments",
          minWidth: 110,
          label: "Payments",
          formatter(val, colDefs, row) {
            if (val) return vm.$theMoney(val) + "&euro;";
            return "-";
          },
        },

        {
          prop: "depts",
          minWidth: 110,
          label: "Depts",
          formatter(val, colDefs, row) {
            if (val) return vm.$theMoney(val) + "&euro;";
            return "-";
          },
        },

        {
          prop: "balances",
          minWidth: 110,
          label: "Balanse",
          formatter(val, colDefs, row) {
            //  return '===';
            // if (!row.payments && !row.depts) return;
            row.payments =
                row.payments && row.payments != "" ? parseFloat(row.payments) : 0;
            row.depts =
                row.depts && row.depts != "" ? parseFloat(row.depts) : 0;

            return vm.$theMoney(row.payments - row.depts) + "&euro;";

            // return "-";
          },
        },
      ];
    },
  },
};
</script >

<style >
.mergebusinesss {
  border: 1px solid red;
}

tr.el-table__row.row-payment {
  background-color: #67c23a5e;
}

tr.el-table__row.row-dept {
  background-color: #e6a23c96;
}

tr.el-table__row.row-archived div {
  text-decoration: line-through;
  color: black;
}

.search.x-row {
  align-items: flex-start;
}

.title {
  color: aliceblue;
  text-align: center;
}

.has-more {
  color: red;
  font-weight: 700;
}
</style >
